// extracted by mini-css-extract-plugin
export var columnList = "_c5-0";